import { rules, rulesText } from './rules'

export function parseToHTML(message: string): string {
  let parsedMessage = ''
  let parsedTextMessage = ''

  if (message) {
    const codeBlocks: string[] = []
    const codeBlockRegex = /```([\s\S]*?)```/g
    message = message.replace(codeBlockRegex, (match: string, code: string) => {
      codeBlocks.push(code.replace(/```([\s\S]*?)\n/g, '```'))
      return `{{CODE{BLOCK}${codeBlocks.length - 1}}}`
    })

    const inlineCodeBlocks: string[] = []
    const inlineCodeRegex = /`([^`]+)`/g
    message = message.replace(inlineCodeRegex, (match: string, code: string) => {
      inlineCodeBlocks.push(code)
      return `{{INLINE{CODE}${inlineCodeBlocks.length - 1}}}`
    })

    parsedMessage = rules.reduce((text, rule) => {
      if (typeof rule.replacement === 'function') {
        return text.replace(rule.regex, rule.replacement as any)
      }
      return text.replace(rule.regex, rule.replacement)
    }, message)

    inlineCodeBlocks.forEach((code, index) => {
      const placeholder = `{{INLINE{CODE}${index}}}`
      parsedMessage = parsedMessage.replace(
        placeholder,
        `<code>${code.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code>`,
      )
    })

    codeBlocks.forEach((code, index) => {
      const placeholder = `{{CODE{BLOCK}${index}}}`
      parsedMessage = parsedMessage.replace(
        placeholder,
        `<pre><code>${code.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code></pre>`,
      )
    })
    parsedTextMessage = rulesText.reduce((text, rule) => {
      if (typeof rule.replacement === 'function') {
        return text.replace(rule.regex, rule.replacement as any)
      }
      return text.replace(rule.regex, rule.replacement)
    }, parsedMessage)
  }

  return parsedTextMessage
}
